import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { NavParams, ToastController, ViewController } from 'ionic-angular';
import { TournamentService } from '../../../gamer/services/tournament.service';
import { IPlayer, ITeam, LineUpService, TshirtStyle, TshirtType } from '../../services/lineup-service';

@Component({
  selector: 'create-team',
  templateUrl: 'create-team.html'
})
export class CreateTeamComponent {
  activePlan: number = 0;

  constructor(
    private viewCtrl: ViewController,
    private toastCtrl: ToastController,
    private translate: TranslateService,
    private navParams: NavParams,
    public ls: LineUpService,
    public gs: TournamentService
  ) { }

  ionViewDidLoad() {
    this.activePlan = this.navParams.get('activePlan') || this.activePlan;
    this.team = this.navParams.get('team') || this.team;
    this.setDefaultColors();
  }

  setDefaultColors() {
    document.documentElement.style.setProperty('--tshirtcolor1', this.ls.field.color1);
    document.documentElement.style.setProperty('--tshirtcolor2', this.ls.field.color2);
  }

  onValueChange(key, value){
    this.ls.field[key] = value;
    this.ls.saveDisplayConfigs();
  }

  onColorSelect(color, index) {
    if (index > 0) {
      this.ls.field.color2 = color;
      document.documentElement.style.setProperty('--tshirtcolor2', color);
    } else {
      this.ls.field.color1 = color;
      document.documentElement.style.setProperty('--tshirtcolor1', color);
    }
  }

  onAddTeam() {
    if (!this.validation()) return;

    this.team.name = this.formGroup.value.name;
    this.gs.planList[this.activePlan].teams.push(this.team);
    this.gs.saveTou(this.gs.planList[this.activePlan]).then(plan => this.gs.planList[this.activePlan] = plan);
    this.gs.save();
    this.viewCtrl.dismiss();
  }

  onDeleteTeam(){
    if (this.gs.planList[this.activePlan]) {
      this.gs.planList[this.activePlan].teams = this.gs.planList[this.activePlan].teams.filter(t => t.id != this.team.id);
      this.gs.removeTeamById(this.team.id);
      this.gs.save();
    }
    this.viewCtrl.dismiss();
  }

  validation(): boolean {
    if (this.formGroup.invalid) {
      this.submitted = true;
      this.toastCtrl.create({
        message: this.translate.instant("FILL_IN_ALL_MESSAGE"),
        position: 'top',
        duration: 3000
      }).present();
      return false;
    }
    return true;
  }

  public get style(): typeof TshirtStyle {
    return TshirtStyle;
  }

  submitted: boolean = false;
  formGroup = new FormGroup({
    name: new FormControl(
      '',
      [
        Validators.required
      ]
    )
  });

  styles = [
    this.translate.instant('ONE_COLOR'),
    this.translate.instant('HORIZONTAL_LINES'),
    this.translate.instant('VERTICAL_LINES')
  ];

  types = [
    this.translate.instant('bandedcollar'),
    this.translate.instant('henley'),
    this.translate.instant('hoodie'),
    this.translate.instant('longsleeves'),
    this.translate.instant('nosleeves'),
    this.translate.instant('polo'),
    this.translate.instant('shirt'),
    this.translate.instant('tshirt'),
    this.translate.instant('vneck')
]

  team: ITeam = {
    id: new Date().getTime(),
    name: "",
    players: [],
    results: 0,
    points: 0,
    ord:0
  };
}




// WEBPACK FOOTER //
// /src/pages/apps/lineup/components/create-team/create-team.ts